export type AssistantPanelVariant = "side" | "floating";

export type AssistantPanelFloatingPosition = {
  x: number;
  y: number;
};

export type AssistantPanelFloatingSize = {
  width: number;
  height: number;
};

export enum AssistantPanelMode {
  HOME = "home",
  AI_CHAT = "ai-chat",
  LEARN = "learn",
}
